import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ChevronDown } from "lucide-react";

const ACCENT = {
  strength: { color: "var(--vedari-sage)", label: "Strength" },
  challenge: { color: "var(--vedari-amber)", label: "Challenge" },
  opportunity: { color: "var(--vedari-rust)", label: "Opportunity" },
};

export default function RevealGlimpses() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => {
    api.post("/reveal/generate").then(r => setCards(r.data.discovery_cards || [])).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen px-6 py-10 max-w-md mx-auto" style={{ color: "var(--vedari-ink)" }}>
      <p className="text-caption tracking-[0.25em] uppercase" style={{ color: "var(--vedari-gold)" }} data-testid="glimpses-eyebrow">
        Three Glimpses
      </p>
      <h1 className="font-display text-3xl mt-3 leading-tight">Three things visible in this phase</h1>

      <div className="space-y-4 mt-8">
        {cards.map((c, i) => {
          const acc = ACCENT[c.type] || ACCENT.strength;
          const isOpen = openIdx === i;
          return (
            <div
              key={c.card_id}
              className="vedari-card cursor-pointer transition-all"
              style={{ animationDelay: `${i * 150}ms` }}
              onClick={() => setOpenIdx(isOpen ? null : i)}
              data-testid={`glimpse-card-${i}`}
            >
              <div className="flex items-start gap-3">
                <div className="w-1 self-stretch rounded-full mt-1" style={{ backgroundColor: acc.color, minHeight: "32px" }} />
                <div className="flex-1">
                  <p className="text-caption uppercase tracking-wider" style={{ color: acc.color }}>{acc.label}</p>
                  <h3 className="font-serif text-h2 mt-1 leading-snug">{c.title}</h3>
                  <p className="text-body mt-3 leading-relaxed" style={{ color: "var(--vedari-ink-soft)" }}>{c.summary}</p>
                  {isOpen && (
                    <p className="text-body mt-4 leading-relaxed border-t pt-4" style={{ color: "var(--vedari-ink)", borderColor: "var(--vedari-divider)" }}>
                      {c.detail}
                    </p>
                  )}
                </div>
                <ChevronDown size={20} className={`mt-2 transition-transform ${isOpen ? "rotate-180" : ""}`} style={{ color: "var(--vedari-ink-soft)" }} />
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-body-sm mt-8 text-center font-serif italic" style={{ color: "var(--vedari-ink-soft)" }}>
        This is what's visible now. Eight more cards will reveal as you walk.
      </p>

      <button onClick={() => navigate("/reveal/resonance")} className="vedari-btn-primary w-full mt-8" data-testid="glimpses-continue-btn">
        Continue
      </button>
    </div>
  );
}
